// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checkbox_wrapper__N7n2x","input":"Checkbox_input__OXM5U","control":"Checkbox_control__PeVXt","icon":"Checkbox_icon__CFsKx"};